import { Box, Divider, Flex, Image } from "@chakra-ui/react";
import featureIcon1 from "../../../assets/aimon/ai.png";
import featureIcon2 from "../../../assets/aimon/lock.png";
import featureIcon3 from "../../../assets/aimon/sphere.png";
import styles from "./Feature.module.scss";
// import gameIcon from "../../../assets/aimon/game.png";

// AI-Driven Evolution
// Harness the power of AI to generate, adapt, and evolve Vimons, creating a unique and ever-changing gameplay experience.
// Blockchain Asset Ownership
// Securely own and trade your Vimons with blockchain technology, ensuring true ownership and a transparent in-game economy.
// Community Co-Creation
// Engage with a vibrant community to co-create content, influence the metaverse, and shape the future of AIMon together
const featureItems = [
  {
    title: "AI-Driven Evolution",
    text: "Harness the power of AI to generate, adapt, and evolve Vimons, creating a unique and ever-changing gameplay experience.",
    icon: featureIcon1,
  },
  {
    title: "Blockchain Asset Ownership",
    text: "Securely own and trade your Vimons with blockchain technology, ensuring true ownership and a transparent in-game economy.",
    icon: featureIcon2,
    reverse: true,
  },
  {
    title: "Community Co-Creation",
    text: "Engage with a vibrant community to co-create content, influence the metaverse, and shape the future of AIMon together",
    icon: featureIcon3,
  },
];

export default function Feature() {
  return (
    <Flex className={styles.container} id="features">
      <Divider className={styles.divider} mb={"40px"} opacity={0.5} />
      <Box className={styles.title} textAlign={"start"} mb={"40px"}>
        {" "}
        Features{" "}
      </Box>

      <Flex className={styles.contentGroup}>
        {featureItems.map((item, index) => (
          <FeatureItem key={index} {...item} />
        ))}
      </Flex>
    </Flex>
  );
}

function FeatureItem({
  title,
  text,
  icon,
  reverse,
}: {
  title: string;
  text: string;
  icon: string;
  reverse?: boolean;
}) {
  const isMobile = window.innerWidth < 768;

  return (
    <Flex
      className={styles.featureItem}
      flexDirection={
        reverse
          ? isMobile
            ? "column"
            : "row-reverse"
          : isMobile
          ? "column"
          : "row"
      }
      justifyContent={isMobile ? "center" : "flex-start"}
      gap={isMobile ? "5%" : "auto"}
    >
      <Image src={icon} alt="logo" className={styles.featureIcon} />
      <Flex className={styles.featureContent}>
        <Box
          className={styles.featureTitle}
          textAlign={isMobile ? "left" : reverse ? "end" : "start"}
        >
          {title}
        </Box>
        <Box
          className={styles.featureText}
          textAlign={isMobile ? "left" : reverse ? "end" : "start"}
          alignSelf={isMobile ? "center" : reverse ? "end" : "start"}
        >
          {text}
        </Box>
      </Flex>
    </Flex>
  );
}
